import { useAxios } from "utils/axiosHook";

const useGetStudents = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/students",
      method: "GET",
    },
    { manual: true }
  );

  const service = () => {
    return api();
  };

  return { data, loading, error, service };
};

const useGetStudent = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "GET",
    },
    { manual: true }
  );

  const service = (id) => {
    return api({ url: `management/students/${id}` });
  };

  return { data, loading, error, service };
};

const useAddStudent = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/students",
      method: "POST",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useUpdateStudent = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "PUT",
    },
    { manual: true }
  );

  const service = (id, data) => {
    return api({
      url: `management/students/${id}`,
      data: data,
    });
  };

  return { data, loading, error, service };
};

const useDeleteStudent = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "DELETE",
    },
    { manual: true }
  );

  const service = (id) => {
    return api({
      url: `management/students/${id}`,
      data: data,
    });
  };

  return { data, loading, error, service };
};

const useDeleteStudents = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      method: "DELETE",
    },
    { manual: true }
  );

  const service = (idArray) => {
    return api({
      url: `management/students`,
      data: { ids: idArray },
    });
  };

  return { data, loading, error, service };
};

const useImportStudentsCSV = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/students/import",
      method: "POST",
    },
    { manual: true }
  );

  const service = (csvData) => {
    return api({ data: { csvData } });
  };

  return { data, loading, error, service };
};

export {
  useGetStudents,
  useGetStudent,
  useAddStudent,
  useUpdateStudent,
  useDeleteStudent,
  useDeleteStudents,
  useImportStudentsCSV,
};
